module.exports = __webpack_public_path__ + "static/img/AIphotoNo.47bf4714.png";